import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import values from "lodash/fp/values";
import { head, reverse, sortBy } from "lodash/fp";

import selectUserChoiceValues from "./selectUserChoiceValues";
import selectSelectedProduct from "./selectSelectedProduct";
import { filterSkus } from "utils";

export default function selectProductExpectedDelivery(state) {
  const selectedCurrency = "CAD";
  const selectedProduct = selectSelectedProduct(state);
  const userChoicesValues = selectUserChoiceValues(state);

  return flow(
    getOr({}, ["skus"]),
    values,
    filterSkus(userChoicesValues),
    sortBy(get(["cost", selectedCurrency])),
    reverse,
    head,
    get("expectedDelivery")
  )(selectedProduct);
}
